import { SpectrogramDouble } from '../src/specgram_double'
import { App, AudioSource } from '../src/data_source'

const N = 4096;

const spec: SpectrogramDouble = new SpectrogramDouble("spec", document.getElementById("spec"), N, N, N, 1e-4, 1e0);

const app = new App();
app.run(null, [spec]);
//
function step(){

    let data = [];
    for (let i = 0; i < N; i++){
      data.push(Math.random());
    }
    spec.update([data]);
}
setInterval(step, 2);
